import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services';
import { PartnerService } from '../../../../services/partner.service';
import { SalesService } from '../../../../services/sales.service';

@Component({
  selector: 'app-bike-sales',
  templateUrl: './bike-sales.component.html',
  styleUrls: ['./bike-sales.component.scss'],
})
export class BikeSalesComponent implements OnInit {
  BikeSaleItem: BikeSaleObject = new BikeSaleObject();
  showBikeSaleDetail: boolean = false;
  BikeSaleItems: BikeSaleObject[] = [];
  BikeSaleItemsFiltered: BikeSaleObject[] = [];

  public partnerId: string = '';
  public partner: any = {};
  public loading: boolean = false;

  public search: string = '';

  public columns: any = [
    { header: 'Name', field: 'Type', type: 'string' },
    { header: 'Product Type(s)', field: 'ProductTypes', type: 'string' },
    { header: 'Product Tag(s)', field: 'ProductTags', type: 'string' },
    {
      header: 'Message Template',
      field: 'LinkedMessageTemplate',
      type: 'string',
    },
  ];

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private saleService: SalesService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    this.getAllSaleTemplates();
  }

  getAllSaleTemplates() {
    this.loading = true;
    this.saleService
      .getSaleCommunnicationTemplate(this.partnerId)
      .subscribe((result) => {
        if (result != '') {
          var obj = JSON.parse(result);
          this.BikeSaleItems = [];
          this.BikeSaleItemsFiltered = [];
          for (var i = 0; i < obj.Templates.length; i++) {
            var item = new BikeSaleObject();
            item.ID = obj.Templates[i].ID;
            item.Type = obj.Templates[i].SaleType;
            item.LinkedMessageTemplateID =
              obj.Templates[i].LinkedMessageTemplateID;
            item.LinkedMessageTemplate = obj.Templates[i].LinkedMessageTemplate;
            item.ProductTags = obj.Templates[i].ProductTags.split(',');
            item.ProductTypes = obj.Templates[i].ProductTypes.split(',');
            this.BikeSaleItems.push(item);
            this.BikeSaleItemsFiltered.push(item);
          }
        }

        this.loading = false;
      });
  }

  addBikeSaleItem() {
    this.BikeSaleItem = new BikeSaleObject();
    this.showBikeSaleDetail = true;
  }

  editBikeSalelistItem(item) {
    this.BikeSaleItem = item;
    this.showBikeSaleDetail = true;
  }

  closeSaleDetail() {
    this.getAllSaleTemplates();
    this.showBikeSaleDetail = false;
  }

  inputChanged() {
    this.BikeSaleItemsFiltered = this.BikeSaleItems;
    this.BikeSaleItemsFiltered = this.BikeSaleItemsFiltered.filter(
      (x) =>
        x.Type.toUpperCase().includes(this.search) ||
        x.ProductTags.join(',').toUpperCase().includes(this.search) ||
        x.ProductTypes.join(',').toUpperCase().includes(this.search),
    );
    console.log(this.BikeSaleItemsFiltered);
  }
}

class BikeSaleObject {
  ID: number = 0;
  Type: string = '';
  ProductTypes: string[] = [];
  ProductTags: string[] = [];
  LinkedMessageTemplateID: number = 0;
  LinkedMessageTemplate: string = '';
}
